.container {
  position: relative;
  display: flex;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-gap: 0px;
  width: 120px;
  height: 120px;
}
.direction-vertical.autoGap .grid {
  grid-template-rows: 1fr;
}
.direction-horizontal.autoGap .grid {
  grid-template-columns: 1fr;
}
.cell {
  height: 40px;
  width: 40px;
  display: flex;
  position: relative;
  cursor: pointer;
}
.cell:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4px;
  height: 4px;
  background-color: var(--theme-secondary-border);
  border-radius: 50%;
}
.direction-vertical.autoGap .cell {
  height: 120px;
}
.direction-horizontal.autoGap .cell {
  width: 120px;
}

.indicatorContainer {
  position: absolute;
  display: flex;
  height: 120px;
  width: 120px;
  top: 0px;
  left: 0px;
  pointer-events: none;
}
.indicator {
  display: flex;
  height: 40px;
  width: 40px;
  padding: 10px;
  box-sizing: border-box;
  background-color: var(--theme-button);
  justify-content: space-between;
}
.autoGap.direction-vertical .indicator {
  padding-top: 20px;
  padding-bottom: 20px;
}
.autoGap.direction-horizontal .indicator {
  padding-left: 20px;
  padding-right: 20px;
}

.direction-vertical .indicator {
  flex-direction: column;
}
.direction-horizontal .indicator {
  flex-direction: row;
}
.direction-vertical.autoGap .indicator {
  height: 120px;
}
.direction-horizontal.autoGap .indicator {
  width: 120px;
}

.hoverIndicator .indicatorChild {
  opacity: 0.3;
  background: var(--theme-inverted-background);
}

.indicatorChild {
  background: var(--theme-button-primary);
  height: 4px;
  width: 4px;
  border-radius: 2.5px;
}
.direction-vertical .indicatorChild:nth-child(1) {
  width: 19px;
}
.direction-vertical .indicatorChild:nth-child(2) {
  width: 9px;
}
.direction-vertical .indicatorChild:nth-child(3) {
  width: 13px;
}
.direction-horizontal .indicatorChild:nth-child(1) {
  height: 19px;
}
.direction-horizontal .indicatorChild:nth-child(2) {
  height: 9px;
}
.direction-horizontal .indicatorChild:nth-child(3) {
  height: 13px;
}

.h-left .indicatorContainer {
  justify-content: start;
}
.h-center .indicatorContainer {
  justify-content: center;
}
.h-right .indicatorContainer {
  justify-content: end;
}
.v-top .indicatorContainer {
  align-items: start;
}
.v-center .indicatorContainer {
  align-items: center;
}
.v-bottom .indicatorContainer {
  align-items: end;
}

.direction-vertical .h-left .indicator {
  align-items: start;
}
.direction-vertical .h-center .indicator {
  align-items: center;
}
.direction-vertical .h-right .indicator {
  align-items: end;
}
.direction-horizontal .v-top .indicator {
  align-items: start;
}
.direction-horizontal .v-center .indicator {
  align-items: center;
}
.direction-horizontal .v-bottom .indicator {
  align-items: end;
}
